/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as u from "react";
const d = (a, o) => {
  const [e, n] = a, [l, c] = u.useState(o);
  return [e !== void 0 ? e : l, (...t) => {
    e !== void 0 ? n(...t) : c(t[0]);
  }];
};
export {
  d as useInheritedState
};
